import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson22 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
  function functionName(){
    statements ...
  }
  `
  );
  const code2 = (
  'text',
  `
  function sayHello(){
    alert("Hello");
  }
   sayHello();
  `
  );
  const code3 = (
  'text',
  `
  sayHello = () => {
    alert("Hello");
  }
   sayHello();
  `
  );
  const code4 = (
  'text',
  `
  function addNumber(a, b) {
  }
  `
  );
  const code5 = (
  'text',
  `
  function addNumber(a, b) {
    return a + b
  }
  console.log(addNumber(2,5)); //7

  //ES6
  addNumber = (a,b) => {
    return a + b
  }
  console.log(addNumber(4,5)); //9
  `
  );
  const code6 = (
  'text',
  `
  function getResult(x,y){
    return x * y
  }
  `
  );
  const code7 = (
  'text',
  `
  function addNumbers(x, y) {
    let num = Math.random() * 10;
    return x + y + num;
  }
  console.log(addNumbers(4,5))
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>Functions</strong></h3>
      <p>Function is a group of <strong>re-usable</strong> which can be called anywhere in your program. This eliminates the need of writing the same code again and again.</p>
      <p>Functions allow a programmer to divide a big code block into a number of small and manageable blocks.</p>
      <p>The way to define a function is to use the <var>function</var> keyword.</p>
      <h4><strong>Function Syntax:</strong></h4>
      <CopyBlock
      language={language}
      text={code1}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
      />
      <h4 className="mt-3"><strong>Example</strong></h4>
      <CopyBlock
      language={language}
      text={code2}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
      />

      <div className="alert alert-secondary mt-3" role="alert">
      <h3 className="mt-3"><strong>Arrow Functions</strong></h3>
        <p>Arrow functions were introduced in ES6 as a new Syntax for writing JavaScript functions and they help to simplify the function scope.</p>
        <p>Also known as <strong><i>Fat arrow functions</i></strong> from CoffeScript (a transcompiled language), Arrow functions are a more concise syntax for writing function expressions.</p>
        <p>They utilize a token <var>=&gt;</var>, which is also called a <strong><i>fat arrow</i></strong>.</p>
        <p>Arrow functions can be anonymous.</p>
        <h4 className="alert-heading">Example</h4>
        <CopyBlock
        language={language}
        text={code3}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
      </div>

        <div id="function-parameter" className="alert alert-secondary mt-3" role="alert">
        <h4 className="alert-heading"><strong>Function Parameters</strong></h4>
        <p>Parameters can be passed while calling a function. These parameters can be captured inside a function and can be manipulated.</p>
        <p>A function can take multiple parameters separated by a comma.</p>
          <CopyBlock
          language={language}
          text={code4}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
        </div>

        <div className="alert alert-secondary mt-3" role="alert">
          <h3 className="mt-3"><strong>Return Statements</strong></h3>
            <p>A return statement is required if you want to return a value from a function.</p>
            <p>The return statement should be the last statement in a function.</p>
            <p class="">NB: The number of parameters passed to the function must be equal to the number of parameters accepted by the function.</p>
            <CopyBlock
            language={language}
            text={code5}
            showLineNumbers={lineNumbers}
            theme={dracula}
            wrapLines={true}
            codeBlock
            />

          <h4 className="mt-3">Note</h4>
          <p>The number of parameters passed to the function must be equal to the number of parameters accepted by the function.</p>
          </div>

        <div className="alert alert-secondary mt-3" role="alert">
        <h3>Pure Functions</h3>
        <p>Pure functions will always return the same result if the same arguments are passed to it and does not have any observable side effect. Its result does not depend on any state or data during execution. There are no modifications of the arguments passed to them.</p>
          <CopyBlock
          language={language}
          text={code6}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />

        <h3 className="mt-3">Impure Functions</h3>
          <p>An impure function is one that changes the internal state one of its arguments or the value of some external variable. Arguments passed to them can be modified.</p>
          <CopyBlock
          language={language}
          text={code7}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
        </div>
       <div className="alert alert-secondary mt-3" role="alert">
        <h3><strong>Summary</strong></h3>
        <ul class="list-group">
          <li class="list-group-item">Functions are re-usable block of code</li>
          <li class="list-group-item">Codes broken down into maintainable and re-usable chunks are easier to maintain</li>
          <li class="list-group-item">You can use ES6 to declare a function withou the <var>function</var> keyword</li>
          <li class="list-group-item">A function can be pure or impure</li>
        </ul>
        </div>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson22
